import { Directive, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CryptoOnboardingFacade } from '@zero/self-service/domain';

@Directive()
export class AcceptContractPageBase {
  public readonly cryptoOnboardingFacade = inject(CryptoOnboardingFacade);
  public readonly activatedRoute = inject(ActivatedRoute);
}
